document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!expanded));
      menuButton.setAttribute('aria-label', expanded ? 'Open navigation menu' : 'Close navigation menu');
      mobileMenu.hidden = expanded;
    });
    mobileMenu.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.setAttribute('aria-label', 'Open navigation menu');
        mobileMenu.hidden = true;
      }
    });
  }

  document.querySelectorAll('[data-product-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.productFilter || 'all';
      const grid = button.closest('.collection')?.querySelector('[data-product-grid]');
      if (!grid) return;
      const cards = [...grid.querySelectorAll('[data-product-card]')];
      let shown = 0;
      cards.forEach((card) => {
        const categories = (card.dataset.productCategory || '').toLowerCase();
        const matches = filter === 'all'
          || categories.includes(filter)
          || (filter === 'social' && /jacket|short|sweatpants|social/.test(categories));
        card.hidden = !matches;
        if (matches) shown += 1;
      });
      const empty = button.closest('.collection')?.querySelector('[data-empty-filter]');
      if (empty) empty.hidden = shown > 0;
      button.closest('.filter-tabs')?.querySelectorAll('[data-product-filter]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });

  document.querySelectorAll('[data-gallery-image]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('.product-gallery');
      const mainImage = gallery?.querySelector('[data-main-product-image]');
      if (!mainImage) return;
      mainImage.src = button.dataset.galleryImage || mainImage.src;
      mainImage.alt = button.dataset.galleryAlt || '';
      gallery.querySelectorAll('[data-gallery-image]').forEach((thumbnail) => {
        const active = thumbnail === button;
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-pressed', String(active));
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const form = select.closest('form');
      const price = form?.querySelector('[data-current-price]');
      const availability = form?.querySelector('[data-current-availability]');
      const addButton = form?.querySelector('[data-add-to-cart]');
      const mainImage = document.querySelector('[data-main-product-image]');
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (availability) availability.textContent = available ? 'Available' : 'Sold out';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to bag' : 'Sold out';
      }
      if (mainImage && option.dataset.image) mainImage.src = option.dataset.image;
    });
  });

  document.querySelectorAll('[data-video-toggle], [data-video-mute]').forEach((button) => {
    button.addEventListener('click', () => {
      const figure = button.closest('.campaign-film');
      const video = figure?.querySelector('video');
      if (!video) return;
      if (button.hasAttribute('data-video-toggle')) {
        if (video.paused) {
          video.play().catch(() => {});
          button.setAttribute('aria-label', 'Pause campaign video');
          const label = button.querySelector('[data-play-label]');
          if (label) label.textContent = 'Pause';
        } else {
          video.pause();
          button.setAttribute('aria-label', 'Play campaign video');
          const label = button.querySelector('[data-play-label]');
          if (label) label.textContent = 'Play';
        }
      } else {
        video.muted = !video.muted;
        button.setAttribute('aria-label', video.muted ? 'Unmute campaign video' : 'Mute campaign video');
        const label = button.querySelector('[data-mute-label]');
        if (label) label.textContent = video.muted ? 'Sound off' : 'Sound on';
      }
    });
  });

  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.assign(url.toString());
    });
  }
});
